import { Context, useContext } from 'react';

export function useActiveContext<T>(context: Context<T>) {
  const ctx = useContext(context);

  if (!ctx) throw new Error(`No context of type ${typeof context} was found`);

  return ctx;
}
